import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";

const SoftwareEngineer: React.FC = () => {
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Career details" pagesub=" Software Engineer (Python)" />
                        <section className="career-details">
                            <div className="container">
                                <div className="cp-details-wrap">

                                    {/* Manager Info */}
                                    <div className="cp-manager_info">
                                        <h2 className="details-content-title mb-30">
                                            Software Engineer (Python) – (Full-time)
                                        </h2>

                                        <ul className="xb-details-content list-unstyled mb-35">
                                            <li><span>Department :</span> Engineering & Development</li>
                                            <li><span>No. of Openings :</span> (3)</li>
                                            <li><span>Job Type :</span> Full-Time</li>
                                            <li><span>Location :</span> Software Technology Park Chattogram, Level 6, Agrabad Circle, Chittagong, Bangladesh</li>
                                            <li><span>Working days : </span>6 days.</li>
                                            <li><span>Salary Range : </span>Negotiable.</li>
                                            <li><span>Experience Required :</span> 0–4 Year (Fresh Graduates Encouraged)</li>
                                        </ul>

                                        <p className="mb-30">
                                           We’re looking for a skilled Software Engineer (Python) to join our engineering team. You will work closely with cross-functional teams to build scalable applications, optimize backend services, and implement clean, reliable, and maintainable code. You should be passionate about backend development, problem-solving, and modern engineering standards.
                                        </p>

                                        <p>
                                            Innovation, ownership, and a strong engineering mindset should come naturally to you. You will help build high-performance systems and contribute to core architectural decisions.
                                        </p>
                                    </div>

                                    {/* What you'll do */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">What you'll get to do...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Build, maintain, and optimize Python-based backend services.</li>
                                            <li>Develop RESTful APIs, microservices, and modular architectures.</li>
                                            <li>Collaborate with engineers, product managers, and designers.</li>
                                            <li>Write clean, scalable, and well-tested code.</li>
                                            <li>Improve system reliability, performance, and security.</li>
                                            <li>Integrate third-party APIs, authentication systems, and databases.</li>
                                            <li>Identify and resolve complex software issues.</li>
                                            <li>Participate in code reviews and contribute to best practices.</li>
                                        </ul>
                                    </div>

                                    {/* Experience section */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Your experience should include...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Professional Python development experience.</li>
                                            <li>Strong foundation in Python, OOP, and design patterns.</li>
                                            <li>Experience with Django, Flask, or FastAPI.</li>
                                            <li>Proficiency in REST API development and integration.</li>
                                            <li>Good understanding of SQL/NoSQL databases (PostgreSQL, MySQL, MongoDB).</li>
                                            <li>Hands-on experience with Git and version control workflows.</li>
                                            <li>Solid understanding of data structures, algorithms, and system design concepts.</li>
                                            <li>Ability to write secure, efficient, and maintainable code.</li>
                                            <li>Strong problem-solving and debugging skills.</li>
                                            <li>Excellent communication and team collaboration abilities.</li>
                                        </ul>
                                    </div>

                                    {/* You might have */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">You might also have...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Experience with Docker and container-based development.</li>
                                            <li>Knowledge of cloud platforms (AWS, Azure, or GCP).</li>
                                            <li>Experience with CI/CD pipelines (GitHub Actions, GitLab CI, Jenkins).</li>
                                            <li>Familiarity with microservice architecture.</li>
                                            <li>Understanding of message queues (RabbitMQ, Kafka).</li>
                                            <li>Exposure to unit testing, integration testing, or TDD.</li>
                                        </ul>
                                    </div>

                                    {/* Benefits */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Great benefits...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Competitive monthly salary with performance reviews.</li>
                                            <li>Opportunity to work on high-scale, real-world applications.</li>
                                            <li>Friendly and collaborative work environment.</li>
                                            <li>Access to learning materials and training sessions.</li>
                                            <li>Flexible working hours.</li>
                                        </ul>
                                    </div>
                                    
                                    {/* ApplyForm */}
                                    <ApplyForm />

                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default SoftwareEngineer;
